<template>
    <div component="SwiperGallery">
        <div class="empty" v-if="!photos.length">
            <img :src="defaultImage" />
        </div>
        <div class="gallery" ref="gallery" v-else load>
            <Flicking ref="slider" :options="options" :plugins="plugins">
                <span slot="viewport" class="flicking-arrow-prev"></span>
                <span slot="viewport" class="flicking-arrow-next"></span>
                <div class="photo" v-for="(item, index) in gallery" :key="index">
                    <img :src="getActorFileUrl(item.file_id)" />
                </div>
                <div slot="viewport" class="flicking-pagination"></div>
            </Flicking>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { Flicking } from '@egjs/vue-flicking';
import { Pagination } from '@egjs/flicking-plugins';
import { Arrow } from '@egjs/flicking-plugins';
import '@egjs/vue-flicking/dist/flicking.css';
import '@egjs/flicking-plugins/dist/flicking-plugins.css';

export default {
    name: 'SwiperGallery',

    props: {
        photos: {
            type: Array,
            required: true,
        },

        defaultImage: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            gallery: [],
            options: {
                horizontal: true,
                panelsPerView: 1,
                // renderOnlyVisible: true,
                align: 'prev',
                circular: false,
                bound: true,
                moveType: 'snap',
                // preventEventsBeforeInit: true,
                inputType: ['touch', 'mouse'],
                autoInit: true,
                // width: 500
            },
            plugins: [new Pagination({ type: 'bullet' }), new Arrow()],
        };
    },

    mounted() {
        this.$nextTick(() => {
            this.gallery = this.photos;
            this.$refs.slider && this.$refs.slider.init();
        });
    },

    beforeDestroy() {
        this.$refs.slider && this.$refs.slider.destroy();
    },

    methods: {
        ...mapActions([]),
        ...mapMutations([]),
    },

    computed: {
        ...mapGetters(['getActorFileUrl']),
    },

    watch: {
        photos(val) {
            this.gallery = [];
            this.$refs.slider && this.$refs.slider.destroy();
            this.$refs.slider && this.$refs.slider.init();

            this.$nextTick(() => {
                this.gallery = val;
            });
        },
    },

    components: {
        Flicking,
    },
};
</script>
<style lang="less" scoped>
@import '~@variables';

[component='SwiperGallery'] {
    width: 500px;
    height: 500px;
    cursor: grab;
    background: white;
    border-right: 1px solid @dark;

    .empty {
        width: 500px;
        height: 500px;
    }

    .gallery {
        position: relative;
        transition: 0.3s;

        &.hide {
            opacity: 0;
        }

        .nav {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            pointer-events: none;
            z-index: 50;

            button {
                position: absolute;
                left: 10px;
                top: 50%;
                transform: translateY(-50%);
                pointer-events: all;

                &.next {
                    left: auto;
                    right: 10px;
                }
            }
        }
    }

    .photo {
        width: 500px;
        height: 500px;
        pointer-events: none;
    }

    img {
        display: block;
        width: 100%;
        height: auto;
    }
}
</style>
